<template>
  <v-app>

    <v-app-bar
               color="#004379"
               class="login-navbar"
    >
      <v-container>
        <v-row class="align-center justify-space-between">
          <img class="hns-logo" src="@/assets/img/HNS logo.png" />
          <span class="text-right white--text font-weight-light text-caption text-sm-body-1">{{todayDate}}</span>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-container
      class="login-bg fill-height"
      fluid
    >

      <v-row
        class="justify-center align-center" align="center" style="height: 100%"
      >
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <v-card
            class="login-card"
          >
            <v-card-title class="pa-0 justify-center">
              <img src="../../assets/img/ematica.svg" />
            </v-card-title>
            <v-card-text class="pa-0 py-6 body-2 black--text" style="line-height: 19px;">
              SUMIT Matica je centralizirani sustav za unos najvažnijih podataka o učenicima i djelatnicima obrazovnih institucija u BiH koje nastavne planove i programe izvode na hrvatskom jeziku.
            </v-card-text>
            <v-card-actions class="pa-0">
              <a style="width: 100%; color: white; text-decoration: none;" @click="login()">
                <div class="login-btn blue elevation-0">
                  <span class="login-btn-icon"><img class="px-3" src="../../assets/img/aai.svg" /></span>
                  <div class="login-btn-text">
                    <v-icon color="white" class="pr-2 text-body-2 text-md-body-1">mdi-shield-check</v-icon>
                    <span class="text-body-2 text-md-body-1 white--text">Prijava putem eduID</span>
                  </div>
                </div>
              </a>
            </v-card-actions>
            <div class="pt-8 d-flex justify-space-between" style="font-weight: 500;">
              <router-link style="text-decoration: none" to="/info">O sustavu</router-link>
              <a href="/info/#pomoc" class="text-right" style="scroll-behavior: smooth; text-decoration:none;">Pomoć</a>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row class="footer align-center" style="color: rgba(0, 0, 0, 0.6);">
        <a href="https://sumit.sum.ba/" target="_blank">
          <v-hover>
            <v-img


              src="../../assets/img/sumit_logo_1.svg"
              class="img-saturation ma-2"
              width="250"
            >
            </v-img>

          </v-hover>
        </a>
        <ul class="footer-links pl-0 pl-lg-12 py-4 py-lg-0">
          <a href="https://skole.sum.ba/skole" style="color: #00000099;" target="blank">Popis obrazovnih institucija</a>
          <a href="/info/#pitanja" style="color: #00000099;">Često postavljena pitanja</a>
        </ul>
        <span class="copyright font-weight-light">SUMIT &copy; {{ new Date().getFullYear() }}</span>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>

export default {
  components: {
  },
  data: () => ({
    logo: "../../assets/img/sum-grey.svg",
    logoHover: "../../assets/img/sumit-color.svg"
  }),
  created () {
    document.title = "SUMIT matica - stranica za prijavu korisnika";
  },
  computed: {
    todayDate() {
      const monthNames = ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj",
        "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"];
      let dateObj = new Date();
      let month = monthNames[dateObj.getMonth()];
      let day = String(dateObj.getDate()).padStart(1, '0');
      let year = dateObj.getFullYear();
      let output = `${day}. ${month} ${year}. godine`

      return output
    }
  },
  methods :{
    login() {
      let apiUrl = process.env.VUE_APP_SKOLE_API_URL;
      window.location.href = `${apiUrl}sso/login?redirect_to=${location.href}admin`
    }
  }
};
</script>

<style>
  .login-bg {
    background-image: url('../../assets/img/login-bg.svg');
    background-size: cover;
    background-color: #E5E5E5;
  }

  .footer-links a {
    display: inline;
    cursor: pointer;
    margin-right: 48px;
    text-decoration: none;
    font-weight: 500;
    text-align: center;
  }

  .login-btn {
    position: relative;
    display: flex;
    width: 100%;
    height: 56px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }

  .login-btn-icon {
    position: absolute;
    left: 0;
    height: 100%;
    background-color: #004379;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .login-card {
    box-shadow: 0px 16px 24px rgba(30, 88, 220, 0.08) !important;
    padding: 48px 40px !important;
  }

  .login-navbar {
    box-shadow: 0px 16px 24px rgba(30, 88, 220, 0.08) !important;
  }

  .copyright {
    margin-left: auto;
  }

  @media only screen and (max-width: 600px) {
    .hns-logo, .sum-logo {
      width: 250px;
    }
    .footer-links {
      display: flex;
      flex-direction: column;
    }
    .footer-links a:not(:last-child) {
      margin-bottom: 16px;
    }
    .footer-links a {
      margin-right: 0px;
    }
  }

  @media only screen and (max-width: 380px) {
    .login-btn-text {
      margin-left: 80px !important;
    }
  }

  @media only screen and (max-width: 1264px) {
    .footer {
      flex-direction: column;
    }
    .copyright {
      margin-left: unset;
    }
  }

  @media only screen and (max-width: 960px) {
    .login-card {
      padding: 24px 20px !important;
    }
    .footer {
      flex-direction: column;
    }
    .login-btn-text {
      margin-left: 50px;
    }
    .copyright {
      margin-left: unset !important;
    }
    .footer-links {
      padding: 0 !important;
    }
    .footer-links li {
      margin-right: 0px;
      margin-top: 8px;
      display: block;
      text-align: center;
    }
  }
  .img-saturation {
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }
  .img-saturation:hover {
    transition-duration: 0.6s;
    -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
    filter: grayscale(0%);
  }
</style>
